<template>
  <div
    class="panoramas panoramas-radius"
  >
    <i-repeat :items="panoramasList">
      <template #default="{ item: panorama }">
        <div class="panorama">
          <i-favorite
            category="panorama"
            small
            :item="panorama"
          />
          <button
            class="panoramas-list-a"
            :class="{
              'active': hoveredPanorama.objectId === panorama.objectId,
              'icon-disabled': panorama.disabled,
              'panoramas-list-a--active': panorama.isActive,
              'disabled': panorama.disabled
            }"
            :disabled="panorama.disabled"
            @mouseenter="setHoveredPanorama(panorama)"
            @mouseleave="setHoveredPanorama({})"
            @click.prevent="panorama.method"
          >
            <div
              class="panoramas-list-icon"
              :class="[{ 'icon-active': panorama.isActive }, panorama.className]"
            >
              <img
                loading="lazy"
                :src="panorama.image"
              >
            </div>
            <span class="panoramas-list-text">
              {{ multiLangValue(panorama) }}
            </span>
          </button>
        </div>
      </template>
    </i-repeat>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IRepeat from '../../IRepeat'
import IFavorite from '../../IFavorite'
import HandleData from '@/mixins/HandleData'

export default {
  name: 'ViewerListPanoramas',
  components: {
    IRepeat,
    IFavorite
  },
  mixins: [
    HandleData
  ],
  data () {
    return {
      isPanoramasReady: false,
      lang: this.$i18n.locale
    }
  },
  computed: {
    ...mapGetters([
      'currentPanorama',
      'hoveredPanorama',
      'isGyroEnabled',
      'isPilotPlaying',
      'isPilotSelfBrowsingMode',
      'krpanoEl',
      'panoramas',
      'property'
    ]),
    panoramasList () {
      const panoramasList = new Array(this.panoramas.length)
      this.panoramas.forEach((panorama, index) => {
        const schema = {
          key: `panorama_${index}`,
          caption: panorama.customCategory || this.$t(panorama.category),
          image: panorama.thumbnail,
          disabled: (this.currentPanorama.objectId === panorama.objectId) || this.isProgressActive || (this.isPilotPlaying && !this.isPilotSelfBrowsingMode),
          isActive: this.currentPanorama.objectId === panorama.objectId,
          method: () => {
            if ((this.currentPanorama.objectId === panorama.objectId) || this.isProgressActive || (this.isPilotPlaying && !this.isPilotSelfBrowsingMode)) {
              return
            }

            const name = this.multiLangValue(panorama, 'en') || panorama.customCategory || this.$t(panorama.category)
            this.$mixpanel.track('Change Panorama', {
              buildingId: panorama.buildingId,
              objectId: panorama.objectId,
              name
            })

            this.selectPanorama(panorama)
            this.closeInformation()
            this.closeShare()
            this.closeMarkerInfo()
            this.closeLocation()
          },
          ...panorama
        }
        panoramasList[index] = schema
      })
      return panoramasList
    }
  },

  mounted () {
    this.isPanoramasReady = true
    window.addEventListener('resize', this.resizeHandler)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    ...mapActions([
      'closeInformation',
      'closeShare',
      'closeMarkerInfo',
      'closeLocation',
      'selectPanorama',
      'setHoveredPanorama'
    ]),

    multiLangValue (panorama, locale = this.lang) {
      if (panorama.categoryMulti) {
        const categoryMulti = JSON.parse(panorama.categoryMulti)
        if (categoryMulti[locale] === undefined) {
          return panorama.caption
        } else {
          return categoryMulti[locale]
        }
      }
      return panorama.caption
    },

    resizeHandler () {
      this.isPanoramasReady = false
      this.$nextTick(() => {
        this.isPanoramasReady = true
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.panoramas .i-repeat::-webkit-scrollbar {
  height: 6px;
}

.panoramas .i-repeat::-webkit-scrollbar-thumb{
  background-color: rgba(255, 255, 255, 0.38);
  border-radius: 20px;
}

.panoramas .i-repeat::-webkit-scrollbar-track {
  background-color: transparent;
}

.panoramas {
  position: relative
  // min-height: 113px
  // don't add height: 100% or it cause Safari height to 0 bug
  width: 100%
  background: -moz-linear-gradient(top, rgba(0,0,0,0.2) 0%, rgba(0,0,0,1) 100%)
  background: -webkit-linear-gradient(top, rgba(0,0,0,0.2) 0%,rgba(0,0,0,1) 100%)
  background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%,rgba(0,0,0,1) 100%)
  filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#33000000,endColorstr=#000,GradientType=0)'
  z-index: $panoramas-z

  & > div {
    overflow-x: auto
    overflow-x: overlay
    overflow-y: hidden
    -webkit-overflow-scrolling: touchs
  }

  .panorama {
    position: relative
  }
  .i-favorite {
    position: absolute
    top: 3px
    left: 3px
  }

  .panoramas-list-a {
    @extend .flex-center-column
    @extend .btn-no-default

    margin: 0
    padding: 0
    width: 6.5rem
    font-size: inherit
    text-align: center

    @media (min-width: $response) {
      width: 10rem
    }
  }

  .panoramas-list-icon {
    @extend .full

    width: inherit
    display: flex
    justify-content: center
    padding-top: 100%
    position: relative
    border-radius: 4px
    overflow: hidden

    &::after {
      content: ''
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-width: 6px
      border-style: solid
      border-radius: inherit
      border-color: transparent

      @media (min-width: $response) {
        border-width: 4px
      }
    }
    img {
      position: absolute
      top: 0
      bottom: 0
      width: 100%
      height: 100%
      object-fit: cover
      margin: auto
    }

    @media (min-width: $response) {
      width: inherit
      padding-top: 61.25%
      z-index: $panoramas-list-icon-z
      transition: transform .25s ease-out
    }
  }

  >>> .i-repeat {
    display: inline-flex
    overflow: auto
    -webkit-overflow-scrolling: touch
    width: 100%

    .i-repeat-li {
      padding: 10px 10px 15px
      display: inline-flex
      flex-shrink: 0
    }

    @media (min-width: $response) {
      padding: 10px

      .i-repeat-li {
        padding: 10px
        display: inline-flex
        flex-shrink: 0
      }
    }
  }
}

.panoramas-list-text {
  @extend .text-ellipsis
  @extend .text-with-gray-bg

  width: inherit
  margin-top: .5em
  position: relative
  display: block
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5)
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .panoramas .i-repeat-li + .i-repeat-li {
    margin-left: auto
    margin-right: $panoramas-i-repeat-li-margin
  }
}
</style>
